import { render, staticRenderFns } from "./PlayerNames.vue?vue&type=template&id=5e4aa3f9&scoped=true"
import script from "./PlayerNames.vue?vue&type=script&lang=js"
export * from "./PlayerNames.vue?vue&type=script&lang=js"
import style0 from "./PlayerNames.vue?vue&type=style&index=0&id=5e4aa3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4aa3f9",
  null
  
)

export default component.exports